module.exports = __webpack_public_path__ + "img/vt-facebook.29363f66.svg";